import { render, staticRenderFns } from "./Notes-Attachment.vue?vue&type=template&id=f732977e"
import script from "./Notes-Attachment.vue?vue&type=script&lang=js"
export * from "./Notes-Attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports